import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { HomepageComponent } from './components/homepage/homepage.component'; // Replace with your main application component
import { AuthGuard } from './guards/auth.guard'; // Import the authentication guard
import { UsersComponent } from './components/users/users.component';
import { ComposersComponent } from './components/composers/composers.component';
import { SongsComponent } from './components/songs/songs.component';
import { RevelsComponent } from './components/revels/revels.component'; // Ensure the path is correct
import { AdminAuthGuard } from './services/auth-guard.service';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'home', component: HomepageComponent, canActivate: [AuthGuard] }, // Protect the main route
  //{ path: 'users', loadChildren: () => import('./components/users/users.component').then(m => m.UsersModule), canActivate: [AdminAuthGuard] },
  { path: 'users', component: UsersComponent, canActivate: [AdminAuthGuard] },
  { path: 'composers', component: ComposersComponent, canActivate: [AuthGuard] },  // Route for User List page
  { path: 'songs', component: SongsComponent, canActivate: [AuthGuard] },  // Route for User List page
  { path: 'revels', component: RevelsComponent, canActivate: [AuthGuard] }, // Route for RevelComponent
  { path: '', redirectTo: '/login', pathMatch: 'full' }, // Redirect to login by default
  { path: '**', redirectTo: '/login' } // Redirect unknown routes to login
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],  // Ensure forRoot() is used
  exports: [RouterModule]
})
export class AppRoutingModule { }
